import { DataGridPremium, GridToolbar } from "@mui/x-data-grid-premium";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { postRequest } from "services/api";

const columns = [
  {
    field: "OrderNumber",
    headerClassName: "headingbg-color",
    headerName: "Order Number",
    flex :1
  },
  {
    field: "ShipDate",
    headerClassName: "headingbg-color",
    headerName: "Ship Date",
    flex :1
  },
  {
    field: "CustPOnumber",
    headerClassName: "headingbg-color",
    headerName: "Customer PO Number",
    flex :1
  },
  {
    field: "ShipTo",
    headerClassName: "headingbg-color",
    headerName: "Ship To",
    flex :1
  },
  {
    field: "BillTo",
    headerClassName: "headingbg-color",
    headerName: "Bill To",
    flex :1
  },

  {
    field: "BLNumber",
    headerClassName: "headingbg-color",
    headerName: "BOL Number",
    flex :1
  },
  {
    field: "LoadNumber",
    headerClassName: "headingbg-color",
    headerName: "Load Number",
    flex :1
  },
  {
    field: "TRAILERKEY",
    headerClassName: "headingbg-color",
    headerName: "Trailer Key",
    flex :1
  },
  {
    field: "TrailerNumber",
    headerClassName: "headingbg-color",
    headerName: "Trailer Number",
    flex :1
  },
  {
    field: "TrailerType",
    headerClassName: "headingbg-color",
    headerName: "Trailer Type",
    flex :1
  },

  {
    field: "OrderQty",
    headerClassName: "headingbg-color",
    headerName: "Order Qty",
    flex :1
  },
  {
    field: "OrderPcs",
    headerClassName: "headingbg-color",
    headerName: "Order Pcs",
    flex :1
  },
  {
    field: "ShippedQty",
    headerClassName: "headingbg-color",
    headerName: "Shipped Qty",
    flex :1
  },
  {
    field: "ShippedPcs",
    headerClassName: "headingbg-color",
    headerName: "Shipped Pcs",
    flex :1
  },

  {
    field: "ItemNumber",
    headerClassName: "headingbg-color",
    headerName: "Item Number",
    flex :1
  },
  {
    field: "Description",
    flex :1,
    headerClassName: "headingbg-color",
    headerName: "Description",
  },
];

const ShipmentReportDateWiseTable = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = React.useState([]);
  const { startDate, endDate } = useSelector((state) => state.dashboard);
  const { user, userSetting } = useSelector((state) => state.user);

  const fetchTableData = async () => {
    setIsLoading(true);
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };
    let payload = {
      orderNo: "all",
      poNo: "all",
      shipTo: "all",
      billTo: "all",
      custCode: userSetting[0].currCustomer,
      whseCode: userSetting[0].currWarehouse,
      fromDate: startDate.format("YYYY-MM-DD"),
      toDate: endDate.format("YYYY-MM-DD"),
    };
    const response = await postRequest(
      "user/getRprt_dateWiseShipmentDtls",
      payload,
      headers
    );
    setData(response.data.Payload);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchTableData();
  }, [startDate, endDate, userSetting]);

  const rows = data.map((c, index) => ({
    id: index,
    Owner: c.Owner,
    WHSEID: c.WHSEID,
    OrderNumber: c.OrderNumber,
    ShipDate: moment(c.ShipDate).format("YYYY-MM-DD"),
    CustPOnumber: c.CustPOnumber,
    ShipTo: c.ShipTo,
    BillTo: c.BillTo,
    BLNumber: c.BLNumber,
    LoadNumber: c.LoadNumber,
    TRAILERKEY: c.TRAILERKEY,
    TrailerNumber: c.TrailerNumber,
    TrailerType: c.TrailerType,
    ItemNumber: c.ItemNumber,
    Description: c.Description,
    OrderQty: c.OrderQty,
    OrderPcs: c.OrderPcs,
    ShippedQty: c.ShippedQty,
    ShippedPcs: c.ShippedPcs
  }));
  return (
    <div
      style={{
        height: 700,
        width: "100%",
        marginTop: "20px",
        background: "#fff",
      }}
    >
      <DataGridPremium
        loading={isLoading}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
          },
        }}
        
        columns={columns}
        rows={rows}
        sx={{ flex: 1, "& .MuiButton-text": { fontSize:  "14px"} }}
        pagination
        pageSizeOptions={[30,50, 100, 200]}
        initialState={{pagination: { paginationModel: { pageSize: 50 } }}}
        //   style={{alignItems: 'center'}}
      ></DataGridPremium>
    </div>
  );
};

export default ShipmentReportDateWiseTable;
